import { PruLogoComponent } from './../pru-logo';
import { NgModule } from '@angular/core';
import { PruNavComponent } from './pru-nav.component';
import { GlobalLinkComponent } from './../global-link';
import { PreNavComponent } from './../pre-nav/pre-nav.component';
import { PrimaryNavComponent } from './../primary-nav';
import { SecondaryNavComponent } from './../secondary-nav';
import { MobileNavComponent } from './../mobile-nav';
import { MobileMenuComponent } from './../mobile-menu';
import { CommonModule } from '@angular/common';
import { MobileActionComponent } from './../mobile-action';
import { SignUpComponent } from './../sign-up';
import { LoginComponent } from './../login';
import { HeaderAccountComponent } from './../header-account';
import { LogoutComponent } from './../logout';
import { SvgFallbackDirective } from './../directives/svg-fallback.directive';
import {
  NavActiveService,
  NavigationService,
  ProfileService,
  UserRoleService,
  WindowRefService
} from './../services';
import { RouterModule } from '@angular/router';
import { StorageRefService } from '../services/storage-ref.service';
import { AlertsService } from '../services/alerts.service';
import { AlertModule } from '../alerts/alert.module';
//import { AlertsCountService } from '../services/alerts-count.service';
import { NavigationStoreService } from '../services/navigation-store.service';

@NgModule({
  imports: [CommonModule, RouterModule, AlertModule],
  providers: [
    WindowRefService,
    NavigationService,
    ProfileService,
    NavActiveService,
    UserRoleService,
    StorageRefService,
    AlertsService,
    //AlertsCountService,
    NavigationStoreService
  ],
  declarations: [
    PruNavComponent,
    GlobalLinkComponent,
    PreNavComponent,
    PrimaryNavComponent,
    SecondaryNavComponent,
    MobileNavComponent,
    MobileMenuComponent,
    PruLogoComponent,
    MobileActionComponent,
    SignUpComponent,
    LoginComponent,
    HeaderAccountComponent,
    LogoutComponent,
    SvgFallbackDirective
  ],
  exports: [
    PruNavComponent,
    GlobalLinkComponent,
    PreNavComponent,
    PrimaryNavComponent,
    SecondaryNavComponent,
    MobileNavComponent,
    MobileMenuComponent,
    PruLogoComponent,
    MobileActionComponent,
    SignUpComponent,
    LoginComponent,
    HeaderAccountComponent,
    LogoutComponent,
    SvgFallbackDirective
  ]
})
// tslint:disable-next-line:no-unnecessary-class
export class PruNavModule { }
